// biGENİŞLETME — Yönetici Paneli: Kurumlar (kurum + koltuk + toplu davet + rapor)
import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box, Button, TextField, MenuItem, Typography, Paper, Chip, Alert,
  Table, TableBody, TableCell, TableHead, TableRow, Dialog, DialogTitle,
  DialogContent, DialogActions, Divider, Stack, LinearProgress,
} from "@mui/material";

const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api/platform/org";
const PKG_API = (process.env.REACT_APP_BACKEND_URL || "") + "/api/packages";

const TYPES = [
  { v: "okul", l: "Okul" }, { v: "universite", l: "Üniversite" },
  { v: "dilmerkezi", l: "Dil Merkezi" }, { v: "isletme", l: "İşletme" },
  { v: "diger", l: "Diğer" },
];

export default function OrgPage() {
  const [orgs, setOrgs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);
  const [sel, setSel] = useState(null);        // seçili kurum (detay)
  const [pools, setPools] = useState([]);
  const [packages, setPackages] = useState([]);
  const [report, setReport] = useState(null);

  const [orgDlg, setOrgDlg] = useState(false);
  const [newOrg, setNewOrg] = useState({ name: "", type: "okul", city: "", contactEmail: "" });

  const [poolDlg, setPoolDlg] = useState(false);
  const [newPool, setNewPool] = useState({ packageId: "", totalSeats: 10 });

  const [inviteDlg, setInviteDlg] = useState(false);
  const [invitePool, setInvitePool] = useState(null);
  const [inviteText, setInviteText] = useState("");
  const [inviteResult, setInviteResult] = useState(null);

  const flash = (t, sev = "success") => { setMsg({ t, sev }); setTimeout(() => setMsg(null), 4000); };

  const loadOrgs = async () => {
    setLoading(true);
    try { const { data } = await axios.get(API + "/"); setOrgs(data.data || []); }
    catch (e) { flash("Kurumlar alınamadı", "error"); }
    setLoading(false);
  };
  const loadPackages = async () => {
    try { const { data } = await axios.get(PKG_API); setPackages(data.data || data || []); } catch (e) {}
  };
  useEffect(() => { loadOrgs(); loadPackages(); }, []);

  const openOrg = async (o) => {
    setReport(null);
    try {
      const { data } = await axios.get(`${API}/${o._id}`);
      setSel(data.data); setPools(data.data.pools || []);
    } catch (e) { flash("Kurum detayı alınamadı", "error"); }
  };

  const createOrg = async () => {
    if (!newOrg.name.trim()) return flash("Kurum adı zorunlu", "warning");
    try {
      await axios.post(API + "/", newOrg);
      setOrgDlg(false); setNewOrg({ name: "", type: "okul", city: "", contactEmail: "" });
      flash("Kurum oluşturuldu"); loadOrgs();
    } catch (e) { flash(e.response?.data?.message || "Oluşturulamadı", "error"); }
  };

  const createPool = async () => {
    if (!newPool.packageId) return flash("Paket seçin", "warning");
    try {
      await axios.post(`${API}/${sel._id}/seatpools`, newPool);
      setPoolDlg(false); setNewPool({ packageId: "", totalSeats: 10 });
      flash("Koltuk havuzu eklendi"); openOrg(sel);
    } catch (e) { flash(e.response?.data?.message || "Havuz eklenemedi", "error"); }
  };

  const openInvite = (pool) => { setInvitePool(pool); setInviteText(""); setInviteResult(null); setInviteDlg(true); };
  const sendInvite = async () => {
    const recipients = inviteText.split(/[\n,;]+/).map((s) => s.trim()).filter(Boolean)
      .map((line) => {
        const parts = line.split(/[\t]+| {2,}/);
        const email = (line.match(/\S+@\S+\.\S+/) || [""])[0];
        const name = line.replace(email, "").trim();
        return { email, name };
      });
    if (!recipients.length) return flash("Liste boş", "warning");
    try {
      const { data } = await axios.post(`${API}/seatpools/${invitePool._id}/invite`, { recipients });
      setInviteResult(data.data || []); flash(`${data.count} davet hazırlandı`); openOrg(sel);
    } catch (e) { flash(e.response?.data?.message || "Davet gönderilemedi", "error"); }
  };

  const loadReport = async () => {
    try { const { data } = await axios.get(`${API}/${sel._id}/report`); setReport(data); }
    catch (e) { flash("Rapor alınamadı", "error"); }
  };

  const usedOf = (p) => (p.assignments || []).filter((a) => a.status === "atandi").length;

  // ---------- DETAY GÖRÜNÜMÜ ----------
  if (sel) {
    return (
      <Box sx={{ p: 1 }}>
        {msg && <Alert severity={msg.sev} sx={{ mb: 2 }}>{msg.t}</Alert>}
        <Button onClick={() => { setSel(null); setReport(null); }} sx={{ mb: 2 }}>← Kurum listesi</Button>
        <Typography variant="h5" fontWeight="bold">{sel.name}</Typography>
        <Chip label={TYPES.find((t) => t.v === sel.type)?.l || sel.type} size="small" sx={{ my: 1 }} />
        <Typography color="text.secondary">{sel.city} {sel.contactEmail}</Typography>

        <Stack direction="row" spacing={2} sx={{ my: 2 }}>
          <Button variant="contained" onClick={() => setPoolDlg(true)}>+ Koltuk Havuzu</Button>
          <Button variant="outlined" onClick={loadReport}>Kurum Raporu</Button>
        </Stack>

        <Typography variant="h6" sx={{ mt: 2 }}>Koltuk Havuzları</Typography>
        {pools.length === 0 && <Typography color="text.secondary">Henüz havuz yok.</Typography>}
        {pools.map((p) => (
          <Paper key={p._id} sx={{ p: 2, my: 1 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" flexWrap="wrap">
              <Box>
                <Typography fontWeight="bold">{p.packageName}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {usedOf(p)} / {p.totalSeats} koltuk kullanımda
                </Typography>
              </Box>
              <Button size="small" variant="contained" onClick={() => openInvite(p)}>Toplu Davet</Button>
            </Stack>
            <LinearProgress variant="determinate"
              value={p.totalSeats ? Math.min(100, (usedOf(p) / p.totalSeats) * 100) : 0}
              sx={{ mt: 1, height: 8, borderRadius: 4 }} />
          </Paper>
        ))}

        {report && (
          <Box sx={{ mt: 3 }}>
            <Typography variant="h6">Rapor — {report.summary.kurum}</Typography>
            <Stack direction="row" spacing={2} sx={{ my: 1 }} flexWrap="wrap">
              <Chip label={`Toplam üye: ${report.summary.toplamUye}`} />
              <Chip color="success" label={`Aktif abonelik: ${report.summary.aktifAbonelik}`} />
              <Chip color="info" label={`Son 7 gün aktif: ${report.summary.son7gunAktif}`} />
              <Chip label={`Ort. XP: ${report.summary.ortalamaXp}`} />
            </Stack>
            <Table size="small">
              <TableHead><TableRow>
                <TableCell>Ad</TableCell><TableCell>E-posta</TableCell><TableCell>Seviye</TableCell>
                <TableCell>XP</TableCell><TableCell>Seri</TableCell><TableCell>Abonelik</TableCell>
              </TableRow></TableHead>
              <TableBody>
                {report.members.map((m) => (
                  <TableRow key={m.userId}>
                    <TableCell>{m.ad}</TableCell><TableCell>{m.email}</TableCell><TableCell>{m.cefr}</TableCell>
                    <TableCell>{m.xp}</TableCell><TableCell>{m.seri}</TableCell>
                    <TableCell>{m.abonelikAktif ? "✅" : "—"}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        )}

        {/* Havuz dialog */}
        <Dialog open={poolDlg} onClose={() => setPoolDlg(false)} fullWidth>
          <DialogTitle>Yeni Koltuk Havuzu</DialogTitle>
          <DialogContent>
            <TextField select fullWidth label="Paket" margin="normal"
              value={newPool.packageId} onChange={(e) => setNewPool({ ...newPool, packageId: e.target.value })}>
              {packages.map((p) => <MenuItem key={p._id} value={p._id}>{p.name} — {p.price}₺</MenuItem>)}
            </TextField>
            <TextField fullWidth type="number" label="Koltuk sayısı" margin="normal"
              value={newPool.totalSeats} onChange={(e) => setNewPool({ ...newPool, totalSeats: Number(e.target.value) })} />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setPoolDlg(false)}>Vazgeç</Button>
            <Button variant="contained" onClick={createPool}>Ekle</Button>
          </DialogActions>
        </Dialog>

        {/* Davet dialog */}
        <Dialog open={inviteDlg} onClose={() => setInviteDlg(false)} fullWidth maxWidth="sm">
          <DialogTitle>Toplu Davet — {invitePool?.packageName}</DialogTitle>
          <DialogContent>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              Her satıra bir e-posta (isteğe bağlı ad). Örn: <code>ayse@okul.com Ayşe Yılmaz</code>
            </Typography>
            <TextField fullWidth multiline minRows={5} placeholder="ogrenci1@ornek.com Ad Soyad&#10;ogrenci2@ornek.com"
              value={inviteText} onChange={(e) => setInviteText(e.target.value)} />
            {inviteResult && (
              <Box sx={{ mt: 2 }}>
                <Alert severity="success">{inviteResult.length} davet hazırlandı</Alert>
                {inviteResult.map((r, i) => (
                  <Typography key={i} variant="caption" display="block" sx={{ mt: .5 }}>
                    {r.email} — {r.status} {r.link ? `→ ${r.link}` : ""}
                  </Typography>
                ))}
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setInviteDlg(false)}>Kapat</Button>
            <Button variant="contained" onClick={sendInvite}>Davet Oluştur</Button>
          </DialogActions>
        </Dialog>
      </Box>
    );
  }

  // ---------- LİSTE GÖRÜNÜMÜ ----------
  return (
    <Box sx={{ p: 1 }}>
      {msg && <Alert severity={msg.sev} sx={{ mb: 2 }}>{msg.t}</Alert>}
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="h5" fontWeight="bold">Kurumlar</Typography>
        <Button variant="contained" onClick={() => setOrgDlg(true)}>+ Yeni Kurum</Button>
      </Stack>
      {loading && <LinearProgress />}
      <Paper>
        <Table>
          <TableHead><TableRow>
            <TableCell>Kurum</TableCell><TableCell>Tür</TableCell><TableCell>Şehir</TableCell>
            <TableCell>Havuz</TableCell><TableCell>Koltuk</TableCell><TableCell></TableCell>
          </TableRow></TableHead>
          <TableBody>
            {orgs.map((o) => (
              <TableRow key={o._id} hover>
                <TableCell>{o.name}</TableCell>
                <TableCell>{TYPES.find((t) => t.v === o.type)?.l || o.type}</TableCell>
                <TableCell>{o.city}</TableCell>
                <TableCell>{o.seatPools}</TableCell>
                <TableCell>{o.usedSeats} / {o.totalSeats}</TableCell>
                <TableCell><Button size="small" onClick={() => openOrg(o)}>Yönet</Button></TableCell>
              </TableRow>
            ))}
            {orgs.length === 0 && !loading && (
              <TableRow><TableCell colSpan={6} align="center" sx={{ color: "text.secondary" }}>
                Henüz kurum yok. "Yeni Kurum" ile başlayın.
              </TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>

      <Dialog open={orgDlg} onClose={() => setOrgDlg(false)} fullWidth>
        <DialogTitle>Yeni Kurum</DialogTitle>
        <DialogContent>
          <TextField fullWidth label="Kurum adı" margin="normal"
            value={newOrg.name} onChange={(e) => setNewOrg({ ...newOrg, name: e.target.value })} />
          <TextField select fullWidth label="Tür" margin="normal"
            value={newOrg.type} onChange={(e) => setNewOrg({ ...newOrg, type: e.target.value })}>
            {TYPES.map((t) => <MenuItem key={t.v} value={t.v}>{t.l}</MenuItem>)}
          </TextField>
          <TextField fullWidth label="Şehir" margin="normal"
            value={newOrg.city} onChange={(e) => setNewOrg({ ...newOrg, city: e.target.value })} />
          <TextField fullWidth label="İletişim e-posta" margin="normal"
            value={newOrg.contactEmail} onChange={(e) => setNewOrg({ ...newOrg, contactEmail: e.target.value })} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOrgDlg(false)}>Vazgeç</Button>
          <Button variant="contained" onClick={createOrg}>Oluştur</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
